(() => {
  'use strict';

  const SIZES = ['36 (S)', '38 (M)', '40 (L)', '42 (XL)', '44 (XXL)'];
  const UI_ID = 'KSShirtSizeV14';
  const SELECT_ID = 'KSShirtSizeV14Select';
  const MIRROR_ID = 'KSShirtSizeV14Mirror';
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  let attempts = 0;

  function addStyles() {
    if (document.getElementById('KSShirtSizeV14Style')) return;
    const style = document.createElement('style');
    style.id = 'KSShirtSizeV14Style';
    style.textContent = `
      #${UI_ID}{display:block!important;width:100%!important;margin:0 0 16px!important;grid-column:1/-1!important}
      #${UI_ID} label{display:block!important;margin:0 0 8px!important;font-weight:700!important;font-size:16px!important;line-height:1.3!important;color:inherit!important}
      #${UI_ID} .ks-size-required{color:#8b0024!important}
      #${UI_ID} .select{display:block!important;width:100%!important;max-width:100%!important;position:relative!important}
      #${UI_ID} select{display:block!important;visibility:visible!important;opacity:1!important;width:100%!important;min-height:54px!important;padding:0 48px 0 16px!important;border:1px solid rgba(0,0,0,.18)!important;border-radius:27px!important;background:#fff!important;color:#222!important;font:inherit!important;font-size:16px!important;line-height:1.2!important;-webkit-appearance:auto!important;appearance:auto!important}
      #${UI_ID} select:focus{outline:2px solid #8b0024!important;outline-offset:2px!important}
      #${UI_ID} .ks-size-error{display:none;margin:7px 2px 0;color:#8b0024;font-size:13px;line-height:1.35}
      #${UI_ID}.is-invalid .ks-size-error{display:block!important}
      [data-ks-v14-legacy-shirt-size="1"]{display:none!important}
      @media(max-width:767px){#${UI_ID}{margin-bottom:14px!important}#${UI_ID} select{min-height:52px!important;font-size:16px!important}}
    `;
    document.head.appendChild(style);
  }

  function findMainForm() {
    return document.querySelector('#MainContent product-info[id^="MainProduct-"] form.main-product-form[data-type="add-to-cart-form"]') ||
      document.querySelector('#MainContent product-info form.main-product-form[data-type="add-to-cart-form"]') ||
      document.querySelector('#MainContent form.main-product-form');
  }

  function findMainProductInfo(form) {
    return form?.closest('product-info') || document.querySelector('#MainContent product-info[id^="MainProduct-"]');
  }

  function buildField(form) {
    let field = form.querySelector(`#${UI_ID}`);
    if (field) return field;

    const buttons = form.querySelector('.product-form__buttons');
    if (!buttons) return null;

    field = document.createElement('div');
    field.id = UI_ID;
    field.className = 'ks-shirt-size-v14';
    field.innerHTML = `
      <label for="${SELECT_ID}">Shirt Size <span class="ks-size-required" aria-hidden="true">*</span></label>
      <div class="select">
        <select id="${SELECT_ID}" name="ks_shirt_size_ui" required aria-required="true">
          <option value="" selected disabled>Select shirt size</option>
          ${SIZES.map(size => `<option value="${size}">${size}</option>`).join('')}
        </select>
      </div>
      <input id="${MIRROR_ID}" type="hidden" name="properties[Shirt Size]" value="" data-ks-property-mirror="1">
      <p class="ks-size-error" role="alert">Please select a shirt size.</p>`;

    form.insertBefore(field, buttons);
    return field;
  }

  function hideNode(node) {
    if (!node || node.closest(`#${UI_ID}`)) return;
    if (node.matches('form, product-info, .product-form__buttons')) return;
    node.dataset.ksV14LegacyShirtSize = '1';
    node.style.setProperty('display', 'none', 'important');
    node.setAttribute('aria-hidden', 'true');
  }

  function cleanupLegacy(form, field) {
    const productInfo = findMainProductInfo(form);
    if (!productInfo) return;

    productInfo.querySelectorAll('select[name="properties[Shirt Size]"],input[name="properties[Shirt Size]"],textarea[name="properties[Shirt Size]"]').forEach(control => {
      if (control.id === MIRROR_ID || control.dataset.ksPropertyMirror === '1' || field.contains(control)) return;
      control.required = false;
      control.disabled = true;
      const wrapper = control.closest('[data-custom-property], .form-field, .product__block--line_item_property, .product__block');
      if (wrapper && !wrapper.contains(field)) hideNode(wrapper);
      else hideNode(control);
    });

    productInfo.querySelectorAll('label').forEach(label => {
      if (label.closest(`#${UI_ID}`)) return;
      if (!normalize(label.textContent).includes('shirt size')) return;
      const wrapper = label.closest('[data-custom-property], .form-field, .product__block--line_item_property, .product__block');
      if (wrapper && !wrapper.contains(field)) hideNode(wrapper);
      else hideNode(label);
    });

    productInfo.querySelectorAll('p, small, span, div').forEach(el => {
      if (el.closest(`#${UI_ID}`)) return;
      if (normalize(el.textContent) !== 'required for this order.') return;
      if (el.querySelector('a,button,input,select,textarea,img,picture')) return;
      hideNode(el);
    });
  }

  function wire(form, field) {
    if (field.dataset.ksReady === '1') return;
    field.dataset.ksReady = '1';

    const select = field.querySelector(`#${SELECT_ID}`);
    const mirror = field.querySelector(`#${MIRROR_ID}`);
    if (!select || !mirror) return;

    const sync = () => {
      mirror.value = select.value || '';
      field.classList.toggle('is-invalid', !select.value);
    };

    const validate = () => {
      sync();
      const ok = Boolean(select.value);
      if (ok) return true;
      field.classList.add('is-invalid');
      field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        select.focus({ preventScroll: true });
        select.reportValidity();
      }, 120);
      return false;
    };

    select.addEventListener('change', sync);
    form.addEventListener('submit', event => {
      if (validate()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    form.addEventListener('click', event => {
      if (!event.target.closest('[name="add"], .shopify-payment-button__button')) return;
      if (validate()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  function install() {
    addStyles();
    const form = findMainForm();
    if (!form) return false;
    const field = buildField(form);
    if (!field) return false;
    cleanupLegacy(form, field);
    wire(form, field);
    return true;
  }

  function start() {
    if (install()) return;
    const timer = setInterval(() => {
      attempts += 1;
      if (install() || attempts >= 40) clearInterval(timer);
    }, 250);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
  document.addEventListener('shopify:section:load', () => { attempts = 0; start(); });

  const observer = new MutationObserver(() => {
    const form = findMainForm();
    const field = form?.querySelector(`#${UI_ID}`);
    if (form && field) cleanupLegacy(form, field);
  });
  const observe = () => document.body && observer.observe(document.body, { childList: true, subtree: true });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', observe, { once: true }) : observe();
})();
